import { ReactNode } from 'react';

type SwapCardWrapperProps = Readonly<{
  disabled: boolean;
  badge?: string;
  cardRef?: (node: HTMLDivElement | null) => void;
  children: ReactNode;
}>;

export default function SwapCardWrapper({
  disabled,
  badge = 'Selected',
  cardRef,
  children
}: SwapCardWrapperProps) {
  return (
    <div ref={cardRef} className='relative'>
      <div className={disabled ? 'pointer-events-none opacity-50' : undefined}>
        {children}
      </div>
      {disabled && (
        <span className='absolute -right-px -top-px rounded-bl-lg rounded-tr-lg bg-gray-500 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white shadow'>
          {badge}
        </span>
      )}
    </div>
  );
}
